import axios from "./axiosInstance";
import { USE_MOCK_API } from "../config/apiConfig";
import mockAddressAPI from "../mocks/services/mockAddressAPI";

const addressAPI = {
  addNewAddress: (payload) => axios.post("users/addresses", payload),

  getAllAddress: () => axios.get("users/addresses"),

  fetchAllAddress: (payload) => axios.post("users/addresses/all", payload),

  deleteAddress: (id) => axios.delete(`users/addresses/${id}`),
};

// export default addressAPI;
export default USE_MOCK_API
    ? mockAddressAPI
    : addressAPI;
